import { render, staticRenderFns } from "./applyDeleteFeeBatch.vue?vue&type=template&id=2783887b"
import script from "./applyDeleteFeeBatch.vue?vue&type=script&lang=js"
export * from "./applyDeleteFeeBatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports